/**
 * @module router/procedure
 * @description UC-REG-160 — Rutas del módulo "Gestiones de trámites".
 *  - /my-procedures         → portal paciente/prestador (form + lista propia)
 *  - /procedures            → bandeja admin/manager (todos los pedidos)
 *  - /procedure-types       → ABM de tipos (admin/manager)
 */
const procedureRoutes = [
  {
    path: "/my-procedures",
    name: "my-procedures",
    component: () =>
      import(
        /* webpackChunkName: "procedure" */ "../components/procedure/MyProcedures.vue"
      ),
  },
  {
    path: "/procedures",
    name: "procedures",
    component: () =>
      import(
        /* webpackChunkName: "procedure" */ "../components/procedure/ProceduresList.vue"
      ),
  },
  {
    path: "/procedure-types",
    name: "procedure-types",
    component: () =>
      import(
        /* webpackChunkName: "procedure" */ "../components/procedure/ProcedureTypeAdmin.vue"
      ),
  },
];

export default procedureRoutes;
